export default "__VITE_ASSET__B1S1kKZq__"